/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UniversalTrackerValuePlain } from '@g17eco/types/universalTrackerValue';
import G17Client from '../services/G17Client';

interface utrMap {
  [key: string]: UniversalTrackerValuePlain[]
}

interface InitialState {
  initiativeId: string;
  data: utrMap;
  errorMessage: string;
  errored: boolean;
  loaded: boolean;
}

const getInitialState = () => {
  return {
    initiativeId: '',
    data: {},
    errorMessage: '',
    errored: false,
    loaded: false
  } as InitialState
}

const utrvChartData = createSlice({
  name: 'utrvChartData',
  initialState: getInitialState(),
  reducers: {
    load: (state, action) => {
      return { ...getInitialState(), initiativeId: action.payload };
    },
    loadUtr: (state, action) => {
      return { ...state, loaded: true, data: { ...state.data, [action.payload.utrId]: action.payload.data } }
    },
    handleError: (state, action: PayloadAction<Error>) => {
      return { ...state, errored: true, errorMessage: action.payload.message };
    },
    unload: () => {
      return getInitialState();
    },
  }
})

export const { load, loadUtr, handleError, unload } = utrvChartData.actions

export const loadByUtrId = (initiativeId: string, utrId: string, hasUpdated: boolean = false) => (dispatch: any, getState: () => any) => {

  if (!initiativeId) {
    return;
  }

  const utrvChartData = getState().utrvChartData;
  if (utrvChartData.initiativeId !== initiativeId) {
    dispatch(load(initiativeId));
  }

  if (!hasUpdated && utrvChartData.data[utrId]) {
    return;
  }
  dispatch(loadUtr({ utrId: utrId, data: [] }))

  G17Client.getInitiativeUtrHistory(initiativeId, utrId)
    .then((models) => {
      dispatch(loadUtr({ utrId: utrId, data: models ?? [] }))
    })
    .catch((e) => handleError(e))
}

export default utrvChartData.reducer

